export default class UserService {
  hasRole = (user: string, roles: Array<string>): boolean => {
    return roles.some(role => user.includes(role));
  };
}
